// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7634a024","453":"8ab09805","667":"1269b30f"}[chunkId] + ".chunk.js";
};